type EditListingEventDetail = {
  listingId: string
  listing: any
  messageId: string
  roomName: string
}

type EditListingSavedDetail = {
  listing: any
}

export const editListingEvents = {
  open: (detail: EditListingEventDetail) => {
    window.dispatchEvent(new CustomEvent('open-edit-listing', { detail }))
  },

  subscribe: (callback: (detail: EditListingEventDetail) => void) => {
    const handler = (e: Event) => {
      callback((e as CustomEvent<EditListingEventDetail>).detail)
    }
    window.addEventListener('open-edit-listing', handler)
    return () => window.removeEventListener('open-edit-listing', handler)
  },

  emitSaved: (detail: EditListingSavedDetail) => {
    window.dispatchEvent(new CustomEvent('edit-listing-saved', { detail }))
  },

  subscribeSaved: (callback: (detail: EditListingSavedDetail) => void) => {
    const handler = (e: Event) => {
      callback((e as CustomEvent<EditListingSavedDetail>).detail)
    }
    window.addEventListener('edit-listing-saved', handler)
    return () => window.removeEventListener('edit-listing-saved', handler)
  },
}
